var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-title row-between",class:{ border: _vm.border },style:({ marginBottom: _vm.bottom + 'px' ,paddingBottom:_vm.pb + 'px'})},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"right"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }